import {QuoteWizardStateService} from '../../../quoteWizardState.service';
import {QuoteWizardNavigationService} from '../../../quoteWizardNavigation.service';
import * as Recaptcha from '../../../../core/directives/recaptcha/recaptcha.provider';
import { UserSignUpRequest, UserSignUpResponse } from '../../../../models/models';
import {Session, Principal, Identity} from '../../../../core/services/sessionService/session.service';
import {ScreenLockService} from '../../../../core/services/screenLockService/screenLock.service';
import {IAuthenticationService} from '../../../../authentication/authentication.service';
import {UserService} from '../../../../core/services/userService/user.service';
import IAppSettings from '../../../../../iApp.settings';

export class EmailController {

    private quoteWizardForm: ng.IFormController;
    private recaptchaWidgetId: string;
    private recaptchaResponse: string;
    private showNextButton: boolean = true;

    public static $inject = ['quoteWizardNavigationService', 'quoteWizardStateService', 'ValidationService',
        'recaptchaService', 'sessionService', 'screenLockService', 'authenticationService', 'userService', 'appSettings'];

    constructor(private navigationService: QuoteWizardNavigationService,
                private stateService: QuoteWizardStateService,
                protected validationService: any,
                private recaptchaService: Recaptcha.IRecaptchaService,
                private sessionService: Session,
                private screenLockService: ScreenLockService,
                private authenticationService: IAuthenticationService,
                private userService: UserService,
                private appSettings: IAppSettings) {

        this.activate();
    }

    private activate(): void {
        this.validationService = new this.validationService();
        this.validationService.setGlobalOptions({controllerAs: this, debounce: 1, hideErrorUnderInputs: true});
        
        if (this.appSettings.bypassRecaptchaGateway === 'true') {
            this.setCaptchaResponse("bypassRecaptchaGateway");
        }
    }

    public setCaptchaWidgetId(widgetId: string): void {
        this.recaptchaWidgetId = widgetId;
    }

    public setCaptchaResponse(response: string): void {
        this.recaptchaResponse = response;
    }

    public resetCaptcha(): void {
        this.recaptchaService.reload(this.recaptchaWidgetId);
        this.recaptchaResponse = undefined;
    }

    public goNext(): void {
        this.validationService.setGlobalOptions({hideErrorUnderInputs: false});

        if (this.quoteWizardForm.$invalid) {
            this.validationService.checkFormValidity(this);
            return;
        }

        if (this.authenticationService.isAuthenticated()) {
            this.navigationService.goNext();
            return;
        }

        this.screenLockService.broadcast(1);

        this.showNextButton = false;


        const signUpRequest = new UserSignUpRequest();
        signUpRequest.emailAddress = this.stateService.viewModel.emailAddress;
        signUpRequest.firstName = this.stateService.viewModel.firstName;
        signUpRequest.lastName = this.stateService.viewModel.lastName;

        const dependency = this.userService.signUp(signUpRequest, this.recaptchaResponse)
        .then((response: UserSignUpResponse) => {

            if(response.isProvisional){

                this.sessionService.isProvisionalSession = response.isProvisional;
                this.stateService.viewModel.clientStateContext.userId = response.id;
                var principal = new Principal();
                principal.identity = new Identity();
                principal.identity.userName = response.firstName;
                principal.identity.email = response.emailAddress;
                principal.claims = [];

                this.sessionService.initializeSession(principal);
                this.navigationService.goNext();
            }
            else{
                this.screenLockService.broadcast(0);
                this.authenticationService.login();
            }
        });
        
        this.stateService.showViewLockIfStillWaitingOnPromise(dependency);
    }

    public goBack(): void {
        this.navigationService.goBack();
    }    
}